import { ReactNode } from "react";
import LunimarModuleShell from "@/components/lunimar/LunimarModuleShell";
import { resolveRealmByTitle, type RealmKey } from "@/components/lunimar/lunimarRealms";

interface ModuleShellProps {
  title: string;
  stepIndex: number;
  totalSteps: number;
  isLocked: boolean;
  lockMessage: string;
  isCompleted: boolean;
  completedMessage?: string;
  completedAction?: ReactNode;
  children: ReactNode;
  stepKey: string;
  /** Optional explicit realm. Falls back to title-based resolution. */
  realmKey?: RealmKey;
}

/**
 * Legacy `ModuleShell` — now a thin adapter that routes every existing
 * module through the immersive Lunimar shell. Props are preserved 1:1 so
 * every page that already imports `ModuleShell` automatically gets the
 * realm-themed environment, mission-control header, holo progress, and
 * mission panel without any logic changes.
 */
const ModuleShell = ({ realmKey, title, ...rest }: ModuleShellProps) => {
  const resolved = realmKey ?? resolveRealmByTitle(title).key;
  return <LunimarModuleShell realmKey={resolved} title={title} {...rest} />;
};

export default ModuleShell;
